// extracted by mini-css-extract-plugin
export default {"questionsContainer":"questions_questionsContainer__ouqIq","questionsContentCont":"questions_questionsContentCont__neDyF"};